<!-- ===== ROWS LIST VIEW ===== -->
<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading && view === 'rows'" class="w-full p-5">
  <div class="text-[16px] font-medium text-gray-900 dark:text-gray-100 mb-3.5">
    All Rows ({{ rows.length.toString().padStart(2, '0') }})
  </div>

  <ng-container *ngIf="hasData">
    <div
      class="relative flex items-center bg-white dark:bg-gray-800 border border-[#75798F] dark:border-gray-700 rounded-xl px-4 py-3 mb-3.5 "
      *ngFor="let row of rows">
      <div class="text-[16px] font-medium text-[#030308] dark:text-gray-100 pr-8 shrink-0 whitespace-nowrap">
        {{ formatRowLabel(row.rowIndex) }}
      </div>
      <div class="absolute top-0 bottom-0 left-[90px] w-px bg-[#75798F] dark:bg-gray-600"></div>
      <div class="flex-1 font-normal text-[16px] text-[#4F6396] dark:text-[#4F6396] pl-9"> --{{ row.norCount === 0 ? '0'
        : row.norCount }} {{ row.norCount === 1 ? 'Position Available' : 'Positions Available' }}-- </div>
      <button class="rounded-lg px-7 py-1 text-[18px] transition-colors font-medium" [ngClass]="row.norCount > 0
          ? 'bg-[#415CFF] dark:bg-[#415CFF] text-white cursor-pointer'
          : 'bg-[#F7F7F7] dark:bg-gray-700 text-[#6B7D8C] dark:text-gray-500 cursor-not-allowed'"
        [disabled]="row.norCount <= 0" (click)="onPlace(row)">
        Place
      </button>
    </div>
  </ng-container>

  <div *ngIf="!hasData" class="flex flex-col items-center w-full mt-10 justify-center">
    <div class="w-full flex items-center justify-center">
      <div #dcmNoRowsAnim class="w-24 h-28"></div>
    </div>
    <p class="text-[#494949] my-4 dark:text-white text-center">--No Rows Available--</p>
  </div>
</div>


<!-- ===== PLACEMENT VIEW ===== -->
<div class="max-w-full px-5" *ngIf="!isLoading && view === 'placement'">
  <button class="flex items-center gap-1 text-[13px] text-[#5A5874] dark:text-gray-400 mb-5 font-normal"
    (click)="goBack()">
    <i class="fa-solid fa-arrow-left"></i>
    <span class="underline">Go Back</span>
  </button>

  <div class="text-[16px] font-normal text-gray-900 dark:text-gray-100 mb-4">
    Selected Row : <span class="font-semibold">{{ formatSelectedRowLabel(selectedRow!.rowIndex) }}</span>
  </div>

  <ng-container *ngIf="hasPositionsData">
   <ng-container *ngFor="let slot of positions; let i = index">
    <div class="mb-4">
      <div class="flex items-center gap-4">
        <div class="flex-1 flex items-stretch rounded-md overflow-hidden border-2 min-h-16"
          [ngClass]="attemptedSave && (isPositionInvalid(slot) || isPositionEmpty(slot)) ? 'border-red-500' : 'border-[#415CFF]'">

          <div
            class="flex justify-center items-center text-[16px] font-medium w-[70px] shrink-0 bg-[#F3F4FF] dark:bg-indigo-950/40">
            PO{{ slot.pIndex }}
          </div>

          <div class="flex-1 bg-white dark:bg-gray-800 flex items-center flex-wrap gap-2 px-3 py-2">
            <span class="flex items-center gap-1.5 border font-normal text-[16px] px-3 py-1.5 rounded-md"
              [ngClass]="isItemDuplicate(item) ? 'bg-[#FFE8E8] dark:bg-red-950/60 border-red-500 text-red-600 dark:text-red-400' : ''"
              *ngFor="let item of slot.items; let j = index">
              {{ item.displayName }} - {{ item.category }}
              <button type="button"
                class="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 leading-none"
                (click)="requestRemoveItem(slot, item, j)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </span>
          </div>

          <div class="flex items-center pr-3">
            <button
              class="w-9 h-9 flex items-center justify-center rounded-md bg-black dark:bg-gray-900 text-white  font-medium hover:bg-gray-800 transition-colors"
              (click)="openAddModal(slot)">
              <i class="fa-solid fa-plus"></i>
            </button>
          </div>
        </div>

        <button type="button"
        [ngClass]="slot.items.length > 0
          ? 'bg-[#F7F7F7] text-gray-400 cursor-not-allowed'
          : 'bg-[#FFF4F4] text-red-500 hover:bg-red-50 cursor-pointer'"
        class="w-16 h-16 shrink-0 flex items-center justify-center rounded-md border transition-colors text-lg shadow-lg"
        [disabled]="slot.items.length > 0"
        (click)="openDeletePositionModal(slot)">
  <i class="fa-solid fa-trash text-lg"
     [ngClass]="slot.items.length > 0 ? 'text-gray-400' : 'text-red-500'">
  </i>
</button>
      </div>

      <div class="flex items-center gap-1.5 text-[13px] text-red-600 dark:text-red-400 mt-1"
        *ngIf="attemptedSave && (isPositionInvalid(slot) || isPositionEmpty(slot))">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span *ngIf="isPositionEmpty(slot)">At least one product is required.</span>
        <span *ngIf="isPositionInvalid(slot)">Duplicate products detected.</span>
      </div>
    </div>
   </ng-container>

    <div class="sticky bottom-0 z-20 -mx-5 px-5 bg-white dark:bg-gray-900 py-5 mt-6 flex justify-center gap-4">
      <button
        class="rounded-lg px-8 py-2 text-[18px] font-medium border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors min-w-16"
        (click)="onCancel()">
        Cancel
      </button>
      <button
        class="rounded-lg px-8 py-2 text-[18px] font-medium bg-[#415CFF] text-white hover:bg-[#415CFF] transition-colors min-w-16"
        (click)="onSave()">
        Save
      </button>
    </div>
  </ng-container>

  <div *ngIf="!hasPositionsData" class="flex flex-col items-center w-full h-screen mt-6">
    <p class="text-[#494949] my-6 dark:text-white">--No Positions Available--</p>
    <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
  </div>
</div>

<!-- ===== PLACE PRODUCT MODAL ===== -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" *ngIf="isModalOpen">
  <div class="bg-white dark:bg-gray-800 rounded-2xl w-full max-w-[520px] p-8 shadow-xl">

    <h2 class="text-center text-[20px] font-semibold text-gray-900 dark:text-gray-100 mb-4">
      Place a Product to Position {{ activeSlotIndex }} from {{ formatSelectedRowLabel(selectedRow!.rowIndex) }}
    </h2>

    <p class="text-[16px] text-center text-[#4F6396] font-normal dark:text-[#4F6396] mb-4">
      Please select the product you need to place for Position {{ activeSlotIndex }}.
    </p>

    <div class="mb-8">
      <app-searchable-dropdown [items]="productDropdownItems" placeholder="--Select Product--"
        searchPlaceholder="Search Products..." [(ngModel)]="selectedProductId" name="productSelect" [clearable]="true"
        [showSelected]="true" borderClass="border border-[#666666] dark:border-gray-600 rounded-xl"
        class="block w-full">
      </app-searchable-dropdown>
    </div>

    <div class="flex justify-between gap-36">
      <button
        class="flex-1 rounded-lg py-3 text-[16px] font-medium border border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-300 bg-[#F7F7F7] dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors min-w-28"
        (click)="closeModal()">
        Cancel
      </button>
      <button class="flex-1 rounded-lg py-3 text-[16px] font-medium transition-colors" [ngClass]="selectedProductId
          ? 'bg-[#415CFF] text-white hover:bg-indigo-700 cursor-pointer'
          : 'bg-[#F0F0F0] dark:bg-gray-700 text-[#B3B3B3] dark:text-gray-500 cursor-not-allowed'"
        [disabled]="!selectedProductId" (click)="confirmPlaceProduct()">
        Place
      </button>
    </div>
  </div>
</div>


<div *ngIf="isRemoveConfirmOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

  <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

    <div
      class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
      <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
        <i class="fa-solid fa-info text-white text-xs"></i>
      </div>
    </div>

    <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
      Confirm Product Remove
    </p>

    <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
      Are you sure you want to remove {{ pendingRemovalItemLabel }} from Position {{ pendingRemovalPosition }}?<br>
      This action cannot be undone.
    </p>

    <div class="flex justify-center gap-3 mt-6">
      <button type="button"
        class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
        (click)="closeRemoveConfirm()">
        Cancel
      </button>

      <button type="button" class="bg-[#FF0000] min-w-36 text-white font-[600] px-6 py-2 rounded-lg "
        (click)="confirmRemove()">
        Remove
      </button>
    </div>
  </div>
</div>

<div *ngIf="showDeletePositionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

    <div class="relative bg-white dark:bg-[#363636] shadow-lg rounded-xl p-6 pt-12 w-2/7 text-center">

        <div
            class="absolute top-4 left-1/2 -translate-x-1/2 flex items-center justify-center w-9 h-9 rounded-full bg-[#BDCCDD33]">
            <div class="flex items-center justify-center w-6 h-6 rounded-full bg-[#57687B]">
                <i class="fa-solid fa-info text-white text-xs"></i>
            </div>
        </div>

        <p class="text-lg font-[600] text-[#000000] dark:text-white mt-4">
            Confirm Position Remove
        </p>

        <p class="font-[400] text-[#4B5563] dark:text-gray-300 mt-3">
            Are you sure you want to remove Position {{ positionToDelete.pIndex }}?

            <BR>
            This action cannot be undone.
        </p>

        <div class="flex justify-center gap-3 mt-6">
            <button type="button"
                class="bg-[#F6F7F9] border min-w-36 border-[#95A1AC] text-[#6B7D8C] font-[600] px-6 py-2 rounded-lg hover:bg-[#dcdcdc]"
                (click)="cancelDeletePosition()">
                Cancel
            </button>

            <button type="button" class="bg-[#FF0000] min-w-36 text-white font-[600] px-6 py-2 rounded-lg "
                (click)="confirmDeletePosition()">
                Delete
            </button>
        </div>
    </div>
</div>